import HonjoSection from './HonjoSection.vue'

export { HonjoSection }
